// extracted by mini-css-extract-plugin
module.exports = {"sendMessageForm":"InboxDetailsSendMessage_sendMessageForm__1FIGs","textAreaMessageForm":"InboxDetailsSendMessage_textAreaMessageForm__OV7Oh"};